import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconCloudSync(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M6.5 20C4.98333 20 3.6875 19.475 2.6125 18.425C1.5375 17.375 1 16.0917 1 14.575C1 13.275 1.39167 12.1167 2.175 11.1C2.95833 10.0833 3.98333 9.43333 5.25 9.15C5.66667 7.61667 6.5 6.375 7.75 5.425C9 4.475 10.4167 4 12 4C13.95 4 15.6042 4.67917 16.9625 6.0375C18.3208 7.39583 19 9.05 19 11C20.15 11.1333 21.1042 11.6292 21.8625 12.4875C22.6208 13.3458 23 14.35 23 15.5C23 16.75 22.5625 17.8125 21.6875 18.6875C20.8125 19.5625 19.75 20 18.5 20H6.5ZM6.5 18H18.5C19.2 18 19.7917 17.7583 20.275 17.275C20.7583 16.7917 21 16.2 21 15.5C21 14.8 20.7583 14.2083 20.275 13.725C19.7917 13.2417 19.2 13 18.5 13H17V11C17 9.61667 16.5125 8.4375 15.5375 7.4625C14.5625 6.4875 13.3833 6 12 6C10.6167 6 9.4375 6.4875 8.4625 7.4625C7.4875 8.4375 7 9.61667 7 11H6.5C5.53333 11 4.70833 11.3417 4.025 12.025C3.34167 12.7083 3 13.5333 3 14.5C3 15.4667 3.34167 16.2917 4.025 16.975C4.70833 17.6583 5.53333 18 6.5 18Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3848 10.2086C15.7299 10.5132 15.7627 11.0398 15.4581 11.3848L10.8377 16.0515C10.6744 16.2365 10.4375 16.3396 10.1908 16.333C9.94413 16.3265 9.71303 16.2109 9.55979 16.0175L7.18016 13.8032C6.89437 13.4424 6.95515 12.9183 7.31591 12.6325C7.67666 12.3467 8.20079 12.4075 8.48657 12.7683L10.2476 14.2016L14.2086 10.2819C14.5132 9.93682 15.0398 9.90402 15.3848 10.2086Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
